import React, { useCallback, useEffect, useRef, useState } from 'react';
import { TOAST_DISMISS_EVENT, TOAST_EVENT } from '../utils/toast';
import './ToastViewport.css';

const MAX_VISIBLE_TOASTS = 3;

export default function ToastViewport() {
  const [items, setItems] = useState([]);
  const timersRef = useRef(new Map());

  const dismiss = useCallback((id) => {
    const timer = timersRef.current.get(id);
    if (timer) window.clearTimeout(timer);
    timersRef.current.delete(id);
    setItems((current) => current.filter((item) => item.id !== id));
  }, []);

  useEffect(() => {
    const timers = timersRef.current;

    const onToast = (event) => {
      const item = event.detail;
      if (!item?.id || !item.message) return;

      setItems((current) => [...current, item].slice(-MAX_VISIBLE_TOASTS));

      if (item.duration > 0) {
        const timer = window.setTimeout(() => dismiss(item.id), item.duration);
        timers.set(item.id, timer);
      }
    };

    const onDismiss = (event) => {
      const id = event.detail?.id;
      if (id == null) {
        timers.forEach((timer) => window.clearTimeout(timer));
        timers.clear();
        setItems([]);
        return;
      }
      dismiss(id);
    };

    window.addEventListener(TOAST_EVENT, onToast);
    window.addEventListener(TOAST_DISMISS_EVENT, onDismiss);

    return () => {
      window.removeEventListener(TOAST_EVENT, onToast);
      window.removeEventListener(TOAST_DISMISS_EVENT, onDismiss);
      timers.forEach((timer) => window.clearTimeout(timer));
      timers.clear();
    };
  }, [dismiss]);

  if (items.length === 0) return null;

  return (
    <div className="toast-viewport" aria-live="polite" aria-atomic="false">
      {items.map((item) => (
        <div
          key={item.id}
          className={`app-toast app-toast-${item.type || 'info'}`}
          role={item.type === 'error' ? 'alert' : 'status'}
        >
          <span className="app-toast-icon" aria-hidden="true">
            {item.type === 'success' ? '✓' : item.type === 'error' ? '!' : item.type === 'warning' ? '⚠' : 'i'}
          </span>
          <span className="app-toast-message">{item.message}</span>
          <button
            type="button"
            className="app-toast-close"
            aria-label="Закрыть сообщение"
            onClick={() => dismiss(item.id)}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
